import { mapKeys, camelCase } from 'lodash';
import { format } from 'date-fns';

import { ValueOf, KeysToCamelCase, Override } from '../../globalTypes';
import {
  APP_STORAGE_FILE_ID_PREFIX,
  CONFIGURATION_DEVICE_TYPES,
  CONFIGURATION_TEST_TYPES,
} from '../../constants';
import constants from './constants';
import { components, paths } from '../../../types/presetsApi.d';

// TODO: proper typing once we've typed our configurations
type PresetPayload = {
  app?: string
  browserConfiguration?: Record<string, unknown>
  deviceType: ValueOf<typeof CONFIGURATION_DEVICE_TYPES>
  mobileAppConfiguration?: Record<string, unknown>
  testType: ValueOf<typeof CONFIGURATION_TEST_TYPES>
  realDeviceConfiguration?: Record<string, unknown>
  tunnel: string | null
  url?: string
  virtualDeviceConfiguration?: Record<string, unknown>
}

// TODO: Consider move types to api.ts or another types file
type ServerPresetSchema = components['schemas']['Preset']
type ServerPreset = Required<Override<ServerPresetSchema, {
  kind: ValueOf<typeof constants.PRESET_KINDS>
  payload: PresetPayload
}>>

// not sure this is the correct way to target the response
type FetchPresetsResponseSchema = paths['/v1/presets']['get']['responses']['200']['content']['application/json'];
type FetchPresetsResponse = Required<Override<FetchPresetsResponseSchema, {
  items: ServerPreset[]
}>>;

class Preset implements KeysToCamelCase<ServerPreset> {
  constructor(attributes: Partial<ServerPreset> = {}) {
    Object.assign(this, { ...mapKeys(attributes, (value, key) => camelCase(key)) });
  }

  isWebTest(): boolean {
    return this.payload.testType === CONFIGURATION_TEST_TYPES.WEB;
  }

  isAppTest(): boolean {
    return this.payload.testType === CONFIGURATION_TEST_TYPES.APP;
  }

  isVdcDevice(): boolean {
    return this.payload.deviceType === CONFIGURATION_DEVICE_TYPES.DESKTOP_BROWSER;
  }

  isVmdDevice(): boolean {
    return this.payload.deviceType === CONFIGURATION_DEVICE_TYPES.VIRTUAL_DEVICE;
  }

  isRdcDevice(): boolean {
    return this.payload.deviceType === CONFIGURATION_DEVICE_TYPES.REAL_DEVICE;
  }

  getAppId(): string {
    return this.payload.app?.replace(APP_STORAGE_FILE_ID_PREFIX, '') ?? '';
  }

  getLastAccessDate(): Date {
    return new Date(this.accessedAt * 1000);
  }

  getPrettyLastAccessDate(): string {
    return `Last used: ${format(this.getLastAccessDate(), constants.LAST_ACCESS_TIME_FORMAT)}`;
  }
}
// trick: create interface with the same name as a class above so we don't
// need to redeclare the members
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Preset extends KeysToCamelCase<ServerPreset> {}

export {
  FetchPresetsResponse,
  Preset,
  PresetPayload,
  ServerPreset,
};
